// The one click from a read in Operate to the same object where it is changed
// (#875). Operate reads the network and Design changes it, so a view in
// Operate that shows something an operator may want to change — a device, a
// switch's ports, a port, the cabling — ends in this link rather than in the
// control, and the link lands on the same object: the address carries the
// device's serial and the port as facets (`facets.ts`), and the Design tab
// reads them.
//
// It is drawn for a caller whose role may make the change there, by the
// page's own `can`; for anyone else the words say where the change is made
// and nothing is offered. The server is the authority either way (§6.2): this
// chooses where an act is offered and grants nothing.
import { ScopeLink } from "./scope";
import type { Facets } from "./facets";
import { Icon } from "../ui";

export default function ChangeInDesign({ to, facets = {}, title }: {
  /** The Design tab's address. */
  to: string;
  /** The object it lands on: `serial`, and `port` for a port. */
  facets?: Facets;
  /** What the change is, for the tooltip. */
  title?: string;
}) {
  return (
    // Restates ADR-0149 decision 1 — Operate offers no write of intent or
    // configuration, and every such change is offered in Design.
    <ScopeLink to={to} facets={facets} className="btn btn-quiet btn-icon" title={title ?? "Operate reads the network and changes nothing here; this is changed in Design."}>
      <Icon name="edit" /><span>Change this in Design</span>
    </ScopeLink>
  );
}
